<form #form="ngForm" class="modal-wrapper" (submit)="saveChanges()">
	<div class="photo-wrapper">
		<label class="label" for="photo">{{
			"UTILS.LABELS.PHOTO" | translate
		}}</label>
		<img
		*ngIf="editedUser?.photo"
			class="listing-photo"
			[src]="editedUser.photo"
			[alt]="'UTILS.LABELS.PHOTO' | translate"
		/>
		<nb-icon class="listing-photo" icon="person" *ngIf="!editedUser?.photo"></nb-icon>
		<input
			#selectPhoto
			id="photo"
			fullWidth
			style="display: none"
			type="file"
			accept="image/*"
			required
			nbInput
			name="photo"
			(change)="onFileSelected($event)"
		/>
		<button
			type="button"
			nbButton
			[size]="getControlElementSize()"
			status="info"
			shape="semi-round"
			size="small"
			fullWidth
			(click)="selectPhoto.click()"
		>
			{{ "PRODUCTS.PRODUCT_EDIT.SELECT_PHOTO_BUTTON" | translate }}
		</button>
	</div>
	<div class="form-wrapper">
		<div class="form-element">
			<label class="label" for="name">{{
				"USERS.FULL_NAME" | translate
			}}</label>
			<input
				nbInput
				[fieldSize]="getControlElementSize()"
				fullWidth
				id="name"
				name="name"
				type="text"
				required
				autocomplete="off"
				[placeholder]="'USERS.FULL_NAME' | translate"
				[(ngModel)]="this.editedUser.name"
				[status]="!this.editedUser.name ? 'danger' : 'basic'"
			/>
		</div>

		<div class="form-element">
			<label class="label" for="email">{{ "AUTH.EMAIL" | translate }}</label>
			<input
				nbInput
				fullWidth
				[fieldSize]="getControlElementSize()"
				id="email"
				name="email"
				autocomplete="email"
				type="text"
				[placeholder]="'AUTH.EMAIL' | translate"
				[(ngModel)]="this.editedUser.email"
				/>
		</div>

		<div class="form-element">
			<label class="label" for="card_nr">{{ "AUTH.CARD_NR" | translate }}</label>
			<input
				nbInput
				fullWidth
				[fieldSize]="getControlElementSize()"
				id="card_nr"
				name="card_nr"
				autocomplete="card_nr"
				type="text"
				[placeholder]="'AUTH.CARD_NR' | translate"
				[(ngModel)]="this.editedUser.card_nr"
				/>
		</div>

		<div class="form-element">
			<label class="label" for="password">{{ "AUTH.PASSWORD" | translate }}</label>
			<input
				nbInput
				fullWidth
				[fieldSize]="getControlElementSize()"
				id="password"
				name="password"
				type="password"
				autocomplete="current-password"
				[minlength]="8"
				[required]="add"
				[placeholder]="'AUTH.PASSWORD' | translate"
				[(ngModel)]="this.editedUser.password"
				[status]="isPasswordValid ? 'basic' : 'danger'"
			/>
		</div>

		<div class="form-element">
			<label class="label" for="roles">{{
				"UTILS.LABELS.ROLE" | translate
			}} {{editedUser.role_name}}</label>
			<nb-select
				[disabled]="user.role_name === 'admin' || profile"
				optionsListClass="options-list"
				[placeholder]="editedUser.role_name === 'admin' ? 'admin' : 'UTILS.LABELS.ROLE' | translate"
				fullWidth
				[size]="getControlElementSize()"
				id="roles"
				name="roles"
				type="text"
				[(ngModel)]="this.editedUser.role_name"
			>
				<nb-option [value]="null">
					{{"SECURITY.NO_ROLE" | translate}}
				</nb-option>
				<nb-option *ngFor="let role of roles" [value]="role.name">
					{{ role.name }}
				</nb-option>
			</nb-select>
		</div>

		<div class="select-wrapper">
			<nb-select-label class="label" for="restaurants">{{
				"UTILS.LABELS.RESTAURANTS" | translate
			}}</nb-select-label>
			<nb-select
			multiple
			[disabled]="editedUser.role_name === 'admin' || profile"
			optionsListClass="options-list"
			[placeholder]="editedUser.role_name === 'admin' ? ('PRODUCTS.PRODUCT.ALL' | translate) : ('UTILS.LABELS.RESTAURANTS' | translate)"
			[size]="getControlElementSize()"
			id="restaurants"
			fullWidth
			name="restaurants"
			type="text"
			(ngModelChange)="onRestaurantsSelected($event)"
			[ngModel]="editedUser.restaurant_ids"
			>
				<nb-option [value]="'all'">
				{{ "PRODUCTS.PRODUCT.ALL" | translate }}
				</nb-option>
				<nb-option
				[disabled]="editedUser.restaurant_ids?.includes('all')"
				*ngFor="let restaurant of restaurants"
				[value]="restaurant.id"
				>
					{{ restaurant.name }}
				</nb-option>
			</nb-select>
		</div>

		<div class="select-wrapper">
			<nb-select-label class="label" for="locations">{{
				"UTILS.LABELS.LOCATIONS" | translate
			}}</nb-select-label>
			<nb-select
			#selectLocation
				multiple
				[compareWith]="compareFn"
				[disabled]="editedUser.role_name === 'admin' || profile"
				optionsListClass="options-list"
				[placeholder]="editedUser.role_name === 'admin' ? ('PRODUCTS.PRODUCT.ALL' | translate) : ('UTILS.LABELS.LOCATIONS' | translate)"
				[size]="getControlElementSize()"
				id="locations"
				fullWidth
				name="locations"
				type="text"
				(ngModelChange)="onLocationsSelected($event)"
				[ngModel]="editedUser.location_ids"
			>
			
			<nb-option-group *ngFor="let restaurant of selectedRestaurants" [title]="restaurant.name">
					<nb-option [value]="restaurant.id.toString()+':all'">
						{{restaurant.name}}-{{ "PRODUCTS.PRODUCT.ALL" | translate }}
					</nb-option>
					<nb-option
						*ngFor="let location of restaurant.locations"
						[value]="location.id.toString()"
					>
						{{ location.name }}
					</nb-option>
				</nb-option-group>
			</nb-select>
		</div>

		<div class="buttons">
			<button
				*ngIf="!this.add"
				nbButton
				fullWidth
				[size]="getControlElementSize()"
				shape="semi-round"
				status="success"
				size="small"
				type="submit"
				class="form-button"
				[disabled]="!this.form.valid"
			>
				{{ "UTILS.SAVE_BUTTON" | translate }}<nb-icon icon="save"></nb-icon>
			</button>
			<button
				*ngIf="!this.add && user.role_name !== 'admin' && !profile"
				nbButton
				fullWidth
				[size]="getControlElementSize()"
				shape="semi-round"
				status="danger"
				size="small"
				type="button"
				(click)="deleteUser()"
				class="form-button"
			>
				{{
					"UTILS.DELETE_BUTTON"
						| translate : { subject: getSubject("USERS.USER_EDIT.USER") }
				}}<nb-icon icon="trash"></nb-icon>
			</button>
			<button
				*ngIf="this.add"
				nbButton
				fullWidth
				[size]="getControlElementSize()"
				shape="semi-round"
				status="success"
				type="submit"
				[disabled]="!this.form.valid"
				class="form-button add"
			>
				{{
					"UTILS.ADD_BUTTON"
						| translate : { subject: getSubject("USERS.USER_EDIT.USER") }
				}}<nb-icon icon="plus"></nb-icon>
			</button>
		</div>
	</div>
</form>
